<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6 md6 lg6>
                        <v-autocomplete
                          :items="busAnFilterList"
                          :label="labels.busAn"
                          v-model="filters.busAn"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('filters.busAn')"
                          data-vv-name="filters.busAn"
                          :data-vv-as="labels.busAn"
                          v-validate="'entry'"
                          clearable
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="getHelpList('busAn')" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs6 md6 lg6>
                        <v-text-field
                          v-model="filters.busAnShortDesc"
                          :label="labels.busAnShortDesc"
                          :error-messages="errors.collect('filters.busAnShortDesc')"
                          data-vv-name="filters.busAnShortDesc"
                          :data-vv-as="labels.busAnShortDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md6 lg6>
                        <v-autocomplete
                          :items="busAnGLFilterList"
                          :label="labels.busAnGL"
                          v-model="filters.busAnGL"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('filters.busAnGL')"
                          data-vv-name="filters.busAnGL"
                          :data-vv-as="labels.busAnGL"
                          v-validate="'entry'"
                          clearable
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="getHelpList('busAnGLFilter')" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs6 md6 lg6>
                        <v-text-field
                          v-model="filters.busAnLongDesc"
                          :label="labels.busAnLongDesc"
                          :error-messages="errors.collect('filters.busAnLongDesc')"
                          data-vv-name="filters.busAnLongDesc"
                          :data-vv-as="labels.busAnLongDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md6 lg6>
                        <v-text-field
                          v-model="filters.busType"
                          :label="labels.busType"
                          :error-messages="errors.collect('filters.busType')"
                          data-vv-name="filters.busType"
                          :data-vv-as="labels.busType"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-flex xs12>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class="mr-2" @click="doNew">
                {{ labels.newButton }}
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
            </v-card-title>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :search="search"
                  :server-items-length="totalItems"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="pagination"
                  item-key="name"
                  :loading="loading"
                  :no-data-text="noDataText"
                  :custom-filter="customSearch"
                >
                  <template v-slot:item="row">
                    <tr>
                      <td class="text-xs-left">{{ row.item.busAn }}</td>
                      <td class="text-xs-left">{{ row.item.busAnShortDesc }}</td>
                      <td class="text-xs-left">{{ row.item.busAnLongDesc }}</td>
                      <td class="text-xs-left">{{ row.item.busAnGL }}</td>
                      <td class="table-action-header">
                        <table-action
                          :rowData="row"
                          query
                          @query="doQuery(row.item)"
                          review
                          @review="doReview(row.item)"
                          remove
                          @remove="doPromptRemove(row.item)"
                        ></table-action>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog v-model="showBusAn" width="1000px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-if="queryMode">mdi-magnify</v-icon>
          <v-icon v-if="reviewMode">mdi-pencil</v-icon>
          <v-toolbar-title v-if="newMode">New Business Analysis Code</v-toolbar-title>
          <v-toolbar-title v-if="queryMode">Query Business Analysis Code</v-toolbar-title>
          <v-toolbar-title v-if="reviewMode">Edit Business Analysis Code</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  :label="labels.busType"
                  v-model="form.busType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="busType"
                  :data-vv-as="labels.busType"
                  :error-messages="errors.collect('busType')"
                  v-validate="'required'"
                  :disabled="this.newMode === false"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.busAn"
                  v-model="form.busAn"
                  item-text="label"
                  item-value="value"
                  data-vv-name="busAn"
                  :data-vv-as="labels.busAn"
                  :error-messages="errors.collect('busAn')"
                  v-validate="'required'"
                  :disabled="this.newMode === false"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.busAnShortDesc"
                  v-model="form.busAnShortDesc"
                  item-text="label"
                  item-value="value"
                  data-vv-name="busAnShortDesc"
                  :data-vv-as="labels.busAnShortDesc"
                  :error-messages="errors.collect('busAnShortDesc')"
                  :disabled="this.queryMode"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :label="labels.busAnLongDesc"
                  v-model="form.busAnLongDesc"
                  item-text="label"
                  item-value="value"
                  data-vv-name="busAnLongDesc"
                  :data-vv-as="labels.busAnLongDesc"
                  :error-messages="errors.collect('busAnLongDesc')"
                  :disabled="this.queryMode"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg6>
                <v-autocomplete
                  :items="busAnGLFilterList"
                  :label="labels.busAnGL"
                  v-model="form.busAnGL"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('form.busAnGL')"
                  data-vv-name="form.busAnGL"
                  :data-vv-as="labels.busAnGL"
                  :disabled="this.queryMode"
                  clearable
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('busAnGL')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ form.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ form.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red darken-1" @click.native="doBack">Cancel</v-btn>
          <v-btn text color="primary" @click.native="doSave" :loading="submitting">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="helplist" width="900px" persistent>
      <!-- Helplist component -->
      <busAnGL-help-list v-if="busAnGLHelplist" @close="doClose" @selectBusAnGL="doAssign($event)"></busAnGL-help-list>
      <busAn-help-list v-if="busAnHelplist" @close="doClose" @selectBusAn="doAssign($event)"></busAn-help-list>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete"> Are you sure to delete the selected Business Analysis Code? - busAn: {{ deleteBusAn }} </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import BusAnGLHelplist from './helplist/BusAnGLHelplist.vue'
import BusAnHelplist from './helplist/BusAnHelplist.vue'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      newMode: false,
      reviewMode: false,
      queryMode: false,
      loading: false,
      submitting: false,
      promptRemove: false,
      showBusAn: false,
      helplist: false,
      filterHelplist: false,
      busAnGLHelplist: false,
      busAnHelplist: false,
      items: [],
      busAnGLFilterList: [],
      busAnFilterList: [],
      totalItems: 0,
      deleteBusAn: '',
      selected: undefined,
      toggleArray: [false],
      labels: {
        newButton: 'New Business Analysis Code',
        busType: 'Business Type',
        busAn: 'Business Analysis Code',
        busAnShortDesc: 'BAC Short Description',
        busAnLongDesc: 'BAC Long Description',
        busAnGL: 'Business Analysis GL Code',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        date: 'date'
      },
      filters: {
        busType: null,
        busAn: null,
        busAnShortDesc: null,
        busAnLongDesc: null,
        busAnGL: null
      },
      form: {
        busType: null,
        busAn: null,
        busAnShortDesc: undefined,
        busAnLongDesc: undefined,
        busAnGL: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        date: new Date()
      },
      headers: [
        { text: 'Business Analysis Code', value: 'busAn' },
        { text: 'BAC Short Description', value: 'busAnShortDesc' },
        { text: 'BAC Long Description', value: 'busAnLongDesc' },
        { text: 'Business Analysis GL Code', value: 'busAnGL' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.getBusAnFilterList('busAnGL')
      this.getBusAnFilterList('busAn')
      this.fetchData() // List with filters
    },
    doClearFilters() {
      this.filters.busType = null
      this.filters.busAn = null
      this.filters.busAnShortDesc = null
      this.filters.busAnLongDesc = null
      this.filters.busAnGL = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.pagination.page = 1
      this.fetchData(false)
    },
    doNew() {
      this.showBusAn = true
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
      this.form.busType = null
      this.form.busAn = null
      this.form.busAnShortDesc = undefined
      this.form.busAnLongDesc = undefined
      this.form.busAnGL = null
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getBusAnPage
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((busAn) => {
                const convertList = {
                  busAn: busAn.busAn,
                  busType: busAn.busType,
                  busAnShortDesc: busAn.busAnShortDesc,
                  busAnLongDesc: busAn.busAnLongDesc,
                  busAnGL: busAn.busAnGL,
                  createdBy: busAn.createdBy,
                  createdDate: busAn.createdDate,
                  modifiedBy: busAn.modifiedBy,
                  modifiedDate: busAn.modifiedDate
                }
                this.items.push(convertList)
              })
            }
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.loading = false
    },
    doQuery(data) {
      this.showBusAn = true
      this.newMode = false
      this.reviewMode = false
      this.queryMode = true
      this.form.busAn = data.busAn
      this.form.busType = data.busType
      this.form.busAnShortDesc = data.busAnShortDesc
      this.form.busAnLongDesc = data.busAnLongDesc
      this.form.busAnGL = data.busAnGL
      this.form.createdBy = data.createdBy
      this.form.createdDate = data.createdDate
      this.form.modifiedBy = data.modifiedBy
      this.form.modifiedDate = data.modifiedDate
    },
    doReview(data) {
      this.showBusAn = true
      this.newMode = false
      this.reviewMode = true
      this.queryMode = false
      this.form.busAn = data.busAn
      this.form.busType = data.busType
      this.form.busAnShortDesc = data.busAnShortDesc
      this.form.busAnLongDesc = data.busAnLongDesc
      this.form.busAnGL = data.busAnGL
      this.form.createdBy = data.createdBy
      this.form.createdDate = data.createdDate
      this.form.modifiedBy = data.modifiedBy
      this.form.modifiedDate = data.modifiedDate
    },
    doDelete() {
      this.resetMessages()
      const apiURI = this.menu.deleteBusAn
      if (apiURI) {
        const expand = this.selected
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit()
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selected = data
      this.promptRemove = true
      this.deleteBusAn = data.busAn
    },
    doBack() {
      this.showBusAn = false
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
      this.form.busType = null
      this.form.busAn = null
      this.form.busAnShortDesc = undefined
      this.form.busAnLongDesc = undefined
      this.form.busAnGL = null
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
      this.form.modifiedBy = undefined
      this.form.modifiedDate = undefined
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createBusAn
      const form = this.form
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
          this.doInit()
          this.showBusAn = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateBusAn
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          this.doInit()
          this.showBusAn = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList(fieldname) {
      this.helplist = true
      if (fieldname === 'busAn') {
        this.filterHelplist = true
        this.busAnHelplist = true
      } else if (fieldname === 'busAnGL') {
        this.filterHelplist = false
        this.busAnGLHelplist = true
      } else if (fieldname === 'busAnGLFilter') {
        this.filterHelplist = true
        this.busAnGLHelplist = true
      }
    },
    doClose() {
      this.resetMessages()
      this.helplist = false
      setTimeout(() => {
        this.busAnGLHelplist = false
        this.busAnHelplist = false
      }, 500)
    },
    doAssign(busAnObj) {
      if (busAnObj.busAnType === 'busAn') {
        this.filters.busAn = busAnObj.busAn
      } else if (busAnObj.busAnType === 'busAnGL') {
        if (this.filterHelplist) {
          this.filters.busAnGL = busAnObj.busAn
        } else {
          this.form.busAnGL = busAnObj.busAn
        }
      }
      this.filterHelplist = false
    },
    async getBusAnFilterList(param) {
      const apiURI = this.menu.getBusAnFilterList
      if (apiURI) {
        try {
          const params = {
            paramName: param
          }
          const result = await this.$http.get(expandURI(apiURI, params))
          if (result.data.dataList) {
            if (param === 'busAnGL') {
              this.busAnGLFilterList = []
              if (result.data.dataList) {
                this.busAnGLFilterList = result.data.dataList
              }
            } else if (param === 'busAn') {
              this.busAnFilterList = []
              if (result.data.dataList) {
                this.busAnFilterList = result.data.dataList
              }
            }
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPermit(data) {
      if (data === 'perInw') {
        this.form.perInw = true
        this.form.perOutw = false
      } else if (data === 'perOutw') {
        this.form.perInw = false
        this.form.perOutw = true
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.busAn.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    'busAnGL-help-list': BusAnGLHelplist,
    'busAn-help-list': BusAnHelplist
  }
}
</script>
